import { render, staticRenderFns } from "./base_line_meun.vue?vue&type=template&id=620b4a37&"
import script from "./base_line_meun.vue?vue&type=script&lang=js&"
export * from "./base_line_meun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports